<template>
  <div>
    <!-- Alert PopUp -->
    <v-dialog v-model="endEmergencyModal" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">
          {{ $t("buttons.stopEmergency") }}
        </v-card-title>
        <v-card-text>
          {{ $t("description.stopEmergency") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="stopEmergency()"
          >
            {{ $t("buttons.yes") }}
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="endEmergencyModal = false"
          >
            {{ $t("buttons.no") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Emergency Create And Update Modal START -->
    <v-dialog persistent v-model="emergencyFormModal" max-width="1000">
      <v-card>
        <v-card-title class="headline indigo lighten-2">
          <div class="text-center white--text" style="width: 100%">
            {{
              $t(`buttons.${ isUpdate
              ? "updateEmergency"
              : "sendEmergency"}`)
            }}
          </div>
        </v-card-title>
        <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
          <form @submit.prevent="handleSubmit(submitEmergencyForm())">
            <v-card-text class="pt-4 text-center d-flex justify-center">
              <div class="text-center" style="width: 100% !important">
                <!-- <ValidationProvider
                  name="Acil Durum Başlığı"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="activeEvent.Title"
                    :label="$t('labels.header')"
                    outlined
                    :error-messages="errors[0]"
                  ></v-text-field>
                </ValidationProvider>
                <ValidationProvider
                  name="Acil Durum Açıklaması"
                  rules="required"
                  v-slot="{ errors }"
                  ><v-text-field
                    v-model="activeEvent.Description"
                    :label="$t('labels.description')"
                    outlined
                    :error-messages="errors[0]"
                  ></v-text-field
                ></ValidationProvider> -->
                <ValidationProvider
                  name="Acil Durum Türü"
                  rules="required"
                  v-slot="{ errors }"
                  >
                  <v-select
                  v-model="activeEvent.EventType"
                  :items="[
                    {
                      text: 'Acil Durum',
                      value: 0
                    },
                    {
                      text: 'Acil Durum Tatbikat',
                      value: 1
                    }
                  ]"
                  item-text="text"
                  item-value="value"
                  outlined
                  :error-messages="errors[0]"
            
               
                  :label="$t('labels.eventType')"
                 ></v-select>
                </ValidationProvider>
                <ValidationProvider
                  v-if="isUpdate"
                  :name="$t('labels.status')"
                  rules="required"
                  v-slot="{ errors }"
                  >
                  <v-select
                  v-model="activeEvent.EventStatus"
                  :items="[
                    {
                      text: 'Aktif',
                      value: 0
                    },
                    {
                      text: 'Pasif',
                      value: 1
                    }
                  ]"
                  item-text="text"
                  item-value="value"
                  outlined
                  :error-messages="errors[0]"
            
               
                  :label="$t('labels.status')"
                 ></v-select>
                </ValidationProvider>
                <v-btn
                  small
                  class="ma-2 mr-4"
                  type="submit"
                  elevation="0"
                  large
                  outlined
                  color="red"
                >
                  {{
                    $t(`buttons.save`)
                  }}
                </v-btn>
                <v-btn
                  small
                  class="ma-2 mr-4"
                  elevation="0"
                  large
                  outlined
                  color="grey"
                  @click="emergencyFormModal = false"
                >
                  {{ $t("buttons.cancel") }}
                </v-btn>
              </div>
            </v-card-text>
          </form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <!-- Emergency Create And Update Modal END -->

    <!-- Emergency deletion modal -->
    <delete-modal :yesFunc="deleteItem" ref="deleteModalRef" />
    <!-- Page content -->
    <v-card style="border-radius: 10px">
      <v-card-title style="color: #595959">
        <v-row>
          <v-col class="py-2">{{ $t("title.emergency") }}</v-col>
          <v-spacer />
          <v-btn
            small
            class="ma-2 mr-4"
            elevation="0"
            outlined
            color="info"
            @click="
              isUpdate = false;
              emergencyFormModal = true;
            "
          >
            {{ $t("buttons.addNewEmergency") }}
          </v-btn>
        </v-row>
      </v-card-title>

      <v-divider />

      <v-card-text class="pt-4"
        ><v-row justify="space-between">
          <v-col cols="2">
            <v-select
              v-model="eventStatus"
              :value="eventStatus"
              :items="eventTypes.concat({ Name: 'Tümü', Code: null })"
              :label="$t('labels.status')"
              item-value="Code"
              item-text="Name"
              @change="changeItemsPerPage()"
            >
            </v-select>
          </v-col>
          <v-col cols="2">
            <v-select
              v-model="itemsPerPage"
              :items="perPageValues"
              :label="$t('labels.selectItemsPerPage')"
              item-value="value"
              item-text="name"
              @change="changeItemsPerPage()"
            >
            </v-select>
          </v-col>
        </v-row>
        <v-data-table
          :headers="headers"
          :items="tableData"
          :loading="$store.state.loadingStatus"
          :options.sync="options"
          :hide-default-footer="true"
          :footer-props="{
            disablePagination: true,
            disableItemsPerPage: true,
          }"
          :no-data-text="$t('description.noList')"
        >
          <!-- eslint-disable -->
          <template v-slot:item.CreatedAt="{ item }">
            {{ convertToLocal(item.CreatedAt) }}
          </template>

          <template v-slot:item.EventType="{ item }">
           <v-chip :color="item.EventType === 0 ? 'red' : 'blue'" dark>{{ item.EventType === 0 ? 'Acil Durum' : 'Tatbikat' }}</v-chip>
          </template>

          <template v-slot:item.CreateByFullName="{ item }">
            {{ item.CreateByFullName ?  item.CreateByFullName : " - " }}
          </template>

          <template v-slot:item.Status="{ item }">
            <v-chip
              v-if="item.EventStatus == 2"
              class="ma-2"
              small
              color="#918c8c"
              text-color="white"
            >
              {{ $t("labels.tooltipEventEnded") }}
            </v-chip>
            <v-chip
              v-if="item.EventStatus == 0"
              class="ma-2"
              small
              color="green"
              text-color="white"
            >
              {{ $t("labels.tooltipActive") }}
            </v-chip>
            <v-chip
              v-if="item.EventStatus == 1"
              class="ma-2"
              small
              color="#339"
              text-color="white"
            >
              {{ $t('titles.paused') }}
            </v-chip>
            <v-chip
              v-if="item.EventStatus == -1"
              class="ma-2"
              small
              color="orange"
              text-color="white"
            >
              Siren
            </v-chip>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip top v-if="item.AnswerCount">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-2"
                  @click="downloadExcel(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-download
                </v-icon>
              </template>
              <span>{{ $t("labels.emergencyDownload") }}</span>
            </v-tooltip>
            <v-tooltip v-if="item.EventStatus !== 2" top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-2"
                  @click="
                    emergencyFormModal = true;
                    changeActiveEvent(item, true);
                  "
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>{{ $t("labels.editEmergency") }}</span>
            </v-tooltip>
            <v-tooltip v-if="item.EventStatus !== 2" top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-2"
                  @click="
                    endEmergencyModal = true;
                    changeActiveEvent(item);
                  "
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-window-close
                </v-icon>
              </template>
              <span>{{ $t("labels.stopEmergency") }}</span>
            </v-tooltip>
            <v-tooltip v-if="item.EventStatus !== 2" top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-2"
                  @click="viewActiveEmergency(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-eye
                </v-icon>
              </template>
              <span>{{ $t("labels.viewEmergency") }}</span>
            </v-tooltip>
            <v-tooltip v-if="item.EventStatus === 2 && item.AnswerCount === 0" top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-2"
                  @click="openDeleteModal(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-delete
                </v-icon>
              </template>
              <span>{{ $t("labels.tooltipDelete") }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <div class="text-xs-center pt-2 md4 lg4">
          <v-pagination
            @input="paginationChangeHandler"
            :value="pagination.page"
            :length="pages"
            :total-visible="10"
            circle
          ></v-pagination>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import EmergencyService from "../services/EmergencyService";
import DeleteModal from "../components/General/DeleteModal";
import GroupService from "../services/GroupService";
import { downloadFile } from "../utils/common";

export default {
  data: () => ({
    // List options
    options: {
      itemsPerPage: 15,
    },
    top: 15,
    skip: 0,
    tableData: [],
    headers: [],

    //Pagination models
    pagination: {},
    itemsPerPage: 15,
    perPageValues: [10, 15, 30, 50, 100],

    form: {
      Title: "",
      Description: "",
      CreateBy: "",
    },

    //Emergency Object
    eventItems: [],
    eventTypes: [],
    eventStatus: null,

    //-1: Oluşturulabilir
    //0: Oluşturuldu - Onay Bekliyor
    //1: Onaylandı
    //2: Silindi
    endEmergencyModal: false,

    activeEvent: {},
    emergencyFormModal: false,
    isUpdate: false
  }),

  watch: {},
  mounted() {
    this.setup();
    this.getTableList();
  },
  components: {
    DeleteModal,
  },

  computed: {
    totalRecords() {
      return this.items.length;
    },
    pageCount() {
      return this.totalRecords / this.itemsPerPage;
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
  },

  methods: {
    setup() {
      this.headers = [
        {
          text: this.$t("title.tableHeaderEmergencyTitle"),
          value: "Title",
          sortable: false,
        },
        {
          text: this.$t("title.tableHeaderEmergencyCreator"),
          value: "CreateBy",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("labels.firstName") + " " + this.$t("labels.lastName"),
          value: "CreateByFullName",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("labels.emergencyType"),
          value: "EventType",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("title.tableHeaderEmergencyDescripption"),
          value: "Description",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("title.tableHeaderCreateDate"),
          value: "CreatedAt",
          sortable: false,
          align: "center",
        },

        {
          text: this.$t("title.tableHeaderStatus"),
          value: "Status",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("title.tableHeaderActions"),
          value: "actions",
          sortable: false,
          align: "center",
        },
        (this.pagination = {
          totalItems: 200,
          rowsPerPage: this.itemsPerPage,
          page: 1,
        }),
      ];
      this.eventTypes = [
        {
          Name: "Siren",
          Code: -1,
        },
        {
          Name: "Aktif",
          Code: 0,
        },
        {
          Name: "Duraklatıldı",
          Code: 1,
        },
        {
          Name: "Kapatıldı",
          Code: 2,
        },
      ];
    },
    //Fill's the emergency list
    getTableList() {
      this.$store.state.loadingStatus = true;

      EmergencyService.getEvents(
        {
          Page: this.pagination.page,
          PageSize: this.pagination.rowsPerPage,
          EventStatus: this.eventStatus
        }
      )
        .then((res) => {
          this.tableData = res.data?.Result;
          this.pagination.totalItems = this.tableData?.TotalItems;
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    /**
     * Change active event for click actions.
     * @param {any} item
     * @param {boolean} isUpdate
     */
    changeActiveEvent(
      item,
      isUpdate = false,
    ) {
      this.activeEvent = Object.assign({}, item);
      this.isUpdate = isUpdate;
    },

    /**
     * Stop emergency from event id.
     */
    stopEmergency() {
      this.activeEvent.EventStatus = 2;
      this.updateEmergency();
    },

    submitEmergencyForm() {
      if (
        this.activeEvent.Title !== "" &&
        this.activeEvent.Description !== ""
      ) {
        if (!this.isUpdate) {
          this.sendEmergency();
        } else {
          this.updateEmergency();
        }
      } else {
        window.showInfo(
          this.$t("description.errorOnCreate"),
          "standart",
          "error"
        );
      }
    },

    sendEmergency() {
      let body = {
        Title: this.activeEvent.Title,
        Description: this.activeEvent.Description,
        CreateBy: this.$store.state.Username,
        EventType: this.activeEvent.EventType,
      };

      this.$store.state.loadingStatus = true;
      EmergencyService.createEvent(body)
        .then((res) => {
          this.emergencyFormModal = false;

          this.getTableList();
          this.reset();
        })
        .catch((err) => {
          window.showError(err);
        })
        .then(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    updateEmergency() {
      const { Title, Description, EventStatus, Id, EventType } = this.activeEvent;
      let body = {
        Title,
        Description,
        EventStatus,
        EventId: Id,
        EventType,
      };
      
      this.$store.state.loadingStatus = true;
      EmergencyService.updateEvent(body)
        .then((res) => {
          this.getTableList();
          this.reset();
          this.reset();
        })
        .catch((err) => {
          window.showError(err);
        })
        .then(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    viewActiveEmergency(item) {
      this.$router.push({ name: "viewEmergency", params: { id: item.Id, item } });
    },

    reset() {
      this.activeEvent = {};
      this.isUpdate = false;
      this.endEmergencyModal = false;
      this.emergencyFormModal = false;
      
      if( this.$refs.observer){
        this.$refs.observer.reset();
      }
    },

    downloadExcel(item) {
      this.$store.state.loadingStatus = true;
      EmergencyService.downloadEventReport({ EventId: item.Id })
        .then((response) => {
          const data = response.data;
          if(data){
            downloadFile(data, `AcilDurumRaporu_${item.Id}_${Date.now()}`, ".xlsx")
          }
        })

        .catch((err) => {
          console.log("ERR >> ", err.Message);
          window.showInfo(
            this.$t("description.emergencyDownloadError"),
            "standart",
            "info"
          );
        })
        .then(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    //Opens modal for deletion operation
    openDeleteModal(item) {
      this.deleteItemModel = item;
      this.$refs.deleteModalRef.modalStatus = true;
    },

    //Delete operation
    deleteItem() {
      this.$store.state.loadingStatus = true;
      EmergencyService.deleteEvent(this.deleteItemModel.Id)
        .then(() => {
          this.reset();
          window.showInfo(
            this.$t("description.successDeleteEmergency"),
            "standart",
            "info"
          );
          this.getTableList();
          this.$refs.deleteModalRef.modalStatus = false;
        })
        .catch(window.showError)
        .then(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    //Change displayed items per page, page number one is default
    changeItemsPerPage() {
      this.pagination.rowsPerPage = this.itemsPerPage;
      this.pagination.page = 1;
      this.options.itemsPerPage = this.itemsPerPage;
      this.getTableList();
    },

    //Change list pagination page
    paginationChangeHandler(pageNumber) {
      this.pagination.page = pageNumber;
      this.getTableList();
    },
  },
};
</script>
